<template>
  <v-app id="app" :dark="darkTheme">
    <v-content fluid fill-height>
      <v-fade-transition>
        <router-view />
      </v-fade-transition>
    </v-content> 
  </v-app>
</template>

<style lang="scss">
      html, body { 
        overflow: hidden !important;
            text-rendering: optimizeLegibility !important;
    font-feature-settings: "kern" !important;
    -webkit-font-feature-settings: "kern" !important;
      }
.application {
    font-family: Segoe UI,Helvetica Neue,Helvetica,Lucida Grande,Arial,Ubuntu,Cantarell,Fira Sans,sans-serif !important;
}

  :root {
    --system-bar-height: 0px;
    --chat-background: var(--v-middleBackground-base);

    .theme--light {
      --divider-color: var(--v-additionalBackground-base);
      --nav-background: #fff;
      --chat-toolbar-background: var(--v-secondary-lighten2);
      --icon-color: rgba(0,0,0,.54);
      --list-item-selected: var(--v-additionalBackground-base);
      --search-bar-background: var(--v-secondary-lighten2);
      --secondary-text: rgba(0,0,0,.54);
      --recv-message-background: var(--v-primary-lighten5);
      --sent-message-background: var(--v-secondary-lighten5);
      --date-message-background: var(--v-secondary-lighten5);
      --nav-drawer-background: var(--v-secondary-lighten5);
      --call-bar-background: var(--v-secondary-lighten5);
      --menu-background: var(--v-secondary-lighten5);
      --menu-item-selected: var(--v-secondary-lighten2);
    }
    .theme--dark {
      --divider-color: var(--v-middleBackground-base);
      --nav-background: var(--v-baseBackground-base);
      --chat-toolbar-background: var(--v-baseBackground-base);
      --icon-color: rgba(255,255,255,.54);
      --list-item-selected: var(--v-additionalBackground-base);
      --search-bar-background: var(--v-secondary-lighten2);
      --secondary-text: hsla(0,0%,100%,.7);
      --recv-message-background: var(--v-secondary-base);
      --sent-message-background: var(--v-secondary-lighten1);
      --date-message-background: var(--v-secondary-lighten2);
      --nav-drawer-background: var(--v-baseBackground-base);
      --call-bar-background: var(--v-baseBackground-darken1);
      --menu-background: var(--v-secondary-base);
      --menu-item-selected: hsla(0,0%,100%,.08);
    }
  }

  .v-icon {
    color: var(--icon-color) !important;
  }

  #app { 
    background-color: var(--v-baseBackground-base);/*#fff; baseBackground*/
  }
 
  #app main {
    height: calc(100vh - var(--system-bar-height)) !important;
  }

  .v-divider--inset:not(.v-divider--vertical) {
    /*margin-left: 83px !important;
    max-width: calc(100% - 83px) !important;*/
    opacity:0.75;
  }

  .emoji {
    width: 20px;
    height: 20px;
    display: inline-block;
    vertical-align:middle;
  }

  .selection { 
    background-color: var(--list-item-selected);
  }

  .v-btn--floating .v-btn__content {
    height: initial !important;
  }

  /*
  .v-system-bar {
    padding: 0 !important;
    z-index: 4;
    font-size:12px; 
    font-family: "Segoe UI", sans-serif;
    color: #fff !important;
  }
  .v-system-bar .drag {
    height: 100%;
    -webkit-app-region: drag;
  }
  .v-system-bar .v-btn {
    height: 24px;
    width: 24px;
    min-width: 24px;
    margin: 0;
    border-radius: 0;
    -webkit-app-region: no-drag;
  }
  .v-system-bar .v-btn .v-btn__content {
    padding: 4px;
  }
  .v-system-bar .v-btn.red--text:before {
    opacity: 1;
  }
  .v-system-bar .v-btn .v-icon {
    margin: 0;
    z-index: 5;
    color: #fff !important;
  }
  .v-system-bar .logo {
    margin: 0 8px 0 8px;
    max-width: 22px;
    max-height: 22px;
  }

  .v-dialog--fullscreen {
    top: var(--system-bar-height) !important;
  }*/
  
</style>

<script>
  import {EventBus} from '@/event-bus'

  export default {
    name: 'app',
    data () {
      return {
        darkTheme: false,
      }
    },
    computed: {
      barColor() {
        return this.darkTheme ? '#383838' : '#BF220C'
      }
    },
    mounted() {
      this.$store.dispatch('readSettings').then(sets => this.themeChanged(sets.theme))
    },
    methods: {
      userAuthorized(result) {
        console.log('-- app userAuthorized: ', result)
        if (result) {
          this.$store.dispatch('isApplicationPinSet').then(isPinSet => { 
            this.$router.replace({name: isPinSet ? 'PinDialog' : 'Main'}) 
          }) 
        } else {
          this.$router.replace({name:'Login'}) 
        }
      },
      themeChanged(isDark) {
        this.darkTheme = isDark
        this.$vuetify.theme = isDark ? this.themes.dark : this.themes.light
      }
    },
    created() {
      EventBus.$on('user-authorized', this.userAuthorized)
      EventBus.$on('theme-changed', this.themeChanged)
    },
    beforeDestroy() {
      EventBus.$off('user-authorized')
      EventBus.$off('theme-changed')
    }
  }
</script>
